module.exports = __webpack_public_path__ + "img/ltkfamily-1x.bc8d695.jpg";